export const ConfigMaps = () => {
    return (
        <div>
            <h1>Maps Configuration</h1>
        </div>
    )
}